import { migrations as chatExerciseMigrations } from './chat-exercise';
import { migrations as cloudExerciseMigrations } from './cloud-exercise';
import { migrations as dragAndDropMigrations } from './drag-and-drop-exercise';
import { migrations as explorableExerciseMigrations } from './explorable-exercise';
import { migrations as gpuExerciseMigrations } from './gpu-exercise';
import { migrations as IDEExerciseMigrations } from './ide-exercise';
import { migrations as pureMultipleChoiceMigrations } from './pure-multiple-choice-exercise';
import { migrations as remoteDesktopExerciseMigrations } from './remote-desktop-exercise';
import { migrations as videoExerciseMigrations } from './video-exercise';
import { migrations as visualExerciseMigrations } from './visual-exercise';
var migrations = {
  ChatExercise: chatExerciseMigrations,
  CloudExercise: cloudExerciseMigrations,
  DragAndDropExercise: dragAndDropMigrations,
  ExplorableExercise: explorableExerciseMigrations,
  GpuExercise: gpuExerciseMigrations,
  IDEExercise: IDEExerciseMigrations,
  PureMultipleChoiceExercise: pureMultipleChoiceMigrations,
  RemoteDesktopExercise: remoteDesktopExerciseMigrations,
  VideoExercise: videoExerciseMigrations,
  VisualExercise: visualExerciseMigrations
};
export default migrations;